var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("check")]),
              _vm._v("Aprobar permiso\n        "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-0" },
            [
              _c(
                "v-container",
                { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", [
                          _c("strong", [_vm._v("Número:")]),
                          _vm._v("   " + _vm._s(_vm.permiso.numero))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", [
                          _c("strong", [_vm._v("Funcionario:")]),
                          _vm._v("   " + _vm._s(_vm.permiso.nombres))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", [
                          _c("strong", [_vm._v("Tipo de papeleta:")]),
                          _vm._v("   " + _vm._s(_vm.permiso.tipo_permiso))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 8
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Lugar de atencion:")]),
                              _vm._v("   " + _vm._s(_vm.permiso.lugar_atencion))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Lugar de comisión  :")]),
                              _vm._v("   " + _vm._s(_vm.permiso.permiso.lugar))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 87 ||
                      _vm.permiso.id_tipo_permiso == 96
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Motivo:")]),
                              _vm._v(" " + _vm._s(_vm.permiso.permiso.motivo))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.permiso.id_tipo_permiso == 90
                        ? _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [
                              _c("strong", [_vm._v("Tipo de baja:")]),
                              _vm._v(" " + _vm._s(_vm.permiso.permiso.motivo))
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", [
                          _c("strong", [_vm._v("Detalles de papeleta")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _vm.permiso.id_tipo_permiso != "24"
                                ? _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.permiso_detalles2,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _vm.permiso.id_tipo_permiso !=
                                              "24"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            props.item
                                                              .fecha_salida
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.permiso.id_tipo_permiso !=
                                              "24"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            props.item
                                                              .fecha_hasta
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_desde
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_hasta
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .total_horas,
                                                            "HH:mm"
                                                          )
                                                          .format("HH:mm")
                                                      )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.total_dias
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.permiso.id_tipo_permiso == 24
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.total_dias
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2563045102
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "pa-2" },
                        [_c("v-spacer")],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("h3", [_c("strong", [_vm._v("Seguimiento :")])])
                          ]),
                          _vm._v(" "),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers_seg_detalle,
                              items: _vm.detalle_seguimiento
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .$moment(props.item._created_at)
                                              .format("DD/MM/YYYY HH:mm")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.estado.descripcion)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            props.item.usuario
                                              ? props.item.usuario
                                                  .nombre_usuario
                                              : ""
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secundary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("check")]),
                  _vm._v("\n          Cancelar\n        ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.apruebaRechazaPermiso(_vm.permiso, 7)
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("check")]),
                  _vm._v("\n          Aprobar\n        ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-163f2288", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163f2288","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/AprobarPermiso.vue
// module id = null
// module chunks = 